import { render, staticRenderFns } from "./TaskMentionActivity.vue?vue&type=template&id=2bf8c5c2"
import script from "./TaskMentionActivity.vue?vue&type=script&lang=js"
export * from "./TaskMentionActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports